import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import OnPaymentMethodCategoriesChange from './onPaymentMethodCategoriesChange.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`Options to configure the payment method manager.`}</p>
    <Group summary='Properties' mdxType="Group">
	<Item title='onPaymentMethodCategoriesChange' subtitle='(paymentMethodCategories: KlarnaPaymentMethodCategory[]) => void' mdxType="Item">
		A callback that is called when the payment categories for Klarna have changed. Sends back an array with the values
		needed to render the payment categories for Klarna.
		<Group mdxType="Group">
			<OnPaymentMethodCategoriesChange mdxType="OnPaymentMethodCategoriesChange" />
		</Group>
	</Item>
    </Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      